import { FC, HTMLProps, ReactNode } from 'react'
import { Box, Grid, makeStyles } from '@perk-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    position: 'relative',
    backgroundColor: '#EAF7FD', // Set background on the main container
    overflow: 'hidden', // Ensure gradient doesn't overflow
    '&::after': {
      content: '""',
      position: 'absolute',
      right: '-30%',
      bottom: '-40%',
      width: '120%',
      height: '120%',
      background:
        'radial-gradient(circle at center, #99EDF5 0%, #99EDF5 20%, rgba(153, 237, 245, 0.5) 40%, transparent 70%)',
      filter: 'blur(100px)',
      opacity: 0.9,
      transform: 'rotate(-4deg)',
      pointerEvents: 'none',
    },
  },
  bannerContainer: {
    height: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'none', // hide banner on md-down
    },
  },
  contentContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& form': {
      width: '100%',
      padding: theme.spacing(2),
    },
  },
  signoutButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 1000,
    padding: theme.spacing(1, 2),
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))

export interface SideBannerContainerProps extends HTMLProps<HTMLDivElement> {
  banner: ReactNode
  bannerWidth?: number // 1..11 (default 4)
  bannerSide?: 'left' | 'right'
}

const SideBannerContainer: FC<SideBannerContainerProps> = ({
  children,
  banner,
  bannerSide = 'left',
  bannerWidth = 4,
}) => {
  const classes = useStyles()
  const bw = Math.max(1, Math.min(11, bannerWidth))
  const cw = 12 - bw

  const BannerCol = (
    <Grid item xs={false} md={bw} className={classes.bannerContainer}>
      {banner}
    </Grid>
  )

  const ContentCol = (
    <Grid item xs={12} md={cw} className={classes.contentContainer}>
      <Box width="100%" mx="auto" px={3}>
        {children}
      </Box>
    </Grid>
  )

  return (
    <Box
      display="flex"
      justifyContent="center"
      width="100%"
      minHeight="100vh"
      className={classes.root}
    >
      <Grid
        container
        wrap="nowrap"
        spacing={0}
        style={{ maxWidth: 1440, flex: 1, position: 'relative', zIndex: 1 }}
      >
        {bannerSide === 'left' ? (
          <>
            {BannerCol}
            {ContentCol}
          </>
        ) : (
          <>
            {ContentCol}
            {BannerCol}
          </>
        )}
      </Grid>
    </Box>
  )
}

export default SideBannerContainer
